export default __webpack_public_path__ + "static/media/Sports shop...26a1b6e6.jpg";